module.exports = "/virtual-football-league/img/amblems/left/Italy/Fake_Roma.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Italy/Fake_Roma.png
// module id = 2043
// module chunks = 4